import _defineProperty from "/codebuild/output/src3618121175/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
var genBorderedStyle = function genBorderedStyle(token) {
  var componentCls = token.componentCls,
    lineWidth = token.lineWidth,
    lineType = token.lineType,
    tableBorderColor = token.tableBorderColor,
    tableHeaderBg = token.tableHeaderBg,
    tablePaddingVertical = token.tablePaddingVertical,
    tablePaddingHorizontal = token.tablePaddingHorizontal,
    calc = token.calc;
  var tableBorder = "".concat(unit(lineWidth), " ").concat(lineType, " ").concat(tableBorderColor);
  var getSizeBorderStyle = function getSizeBorderStyle(size, paddingVertical, paddingHorizontal) {
    return _defineProperty({}, "&".concat(componentCls, "-").concat(size), _defineProperty({}, "> ".concat(componentCls, "-container"), _defineProperty({}, "> ".concat(componentCls, "-content, > ").concat(componentCls, "-body"), _defineProperty({}, "\n            > table > tbody > tr > th,\n            > table > tbody > tr > td\n          ", _defineProperty({}, "> ".concat(componentCls, "-expanded-row-fixed"), {
      margin: "".concat(unit(calc(paddingVertical).mul(-1).equal()), "\n              ").concat(unit(calc(calc(paddingHorizontal).add(lineWidth)).mul(-1).equal()))
    })))));
  };
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), _defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls).concat(componentCls, "-bordered"), Object.assign(Object.assign(Object.assign(_defineProperty(_defineProperty(_defineProperty({}, "> ".concat(componentCls, "-title"), {
    border: tableBorder,
    borderBottom: 0
  }), "> ".concat(componentCls, "-container"), _defineProperty({
    borderInlineStart: tableBorder,
    borderTop: tableBorder
  }, "\n            > ".concat(componentCls, "-content,\n            > ").concat(componentCls, "-header,\n            > ").concat(componentCls, "-body,\n            > ").concat(componentCls, "-summary\n          "), {
    '> table': _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "\n                > thead > tr > th,\n                > thead > tr > td,\n                > tbody > tr > th,\n                > tbody > tr > td,\n                > tfoot > tr > th,\n                > tfoot > tr > td\n              ", {
      borderInlineEnd: tableBorder
    }), '> thead', {
      '> tr:not(:last-child) > th': {
        borderBottom: tableBorder
      },
      '> tr > th::before': {
        backgroundColor: 'transparent !important'
      }
    }), "\n                > thead > tr,\n                > tbody > tr,\n                > tfoot > tr\n              ", _defineProperty({}, "> ".concat(componentCls, "-cell-fix-right-first::after"), {
      borderInlineEnd: tableBorder
    })), "\n                > tbody > tr > th,\n                > tbody > tr > td\n              ", _defineProperty({}, "> ".concat(componentCls, "-expanded-row-fixed"), {
      margin: "".concat(unit(calc(tablePaddingVertical).mul(-1).equal()), " ").concat(unit(calc(calc(tablePaddingHorizontal).add(lineWidth)).mul(-1).equal())),
      '&::after': {
        position: 'absolute',
        top: 0,
        insetInlineEnd: lineWidth,
        bottom: 0,
        borderInlineEnd: tableBorder,
        content: '""'
      }
    }))
  })), "&".concat(componentCls, "-scroll-horizontal"), _defineProperty({}, "> ".concat(componentCls, "-container > ").concat(componentCls, "-body"), {
    '> table > tbody': _defineProperty({}, "\n                > tr".concat(componentCls, "-expanded-row,\n                > tr").concat(componentCls, "-placeholder\n              "), {
      '> th, > td': {
        borderInlineEnd: 0
      }
    })
  })), getSizeBorderStyle('middle', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle)), getSizeBorderStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall)), _defineProperty({}, "> ".concat(componentCls, "-footer"), {
    border: tableBorder,
    borderTop: 0
  }))), "".concat(componentCls, "-cell"), _defineProperty(_defineProperty({}, "".concat(componentCls, "-container:first-child"), {
    // :first-child to avoid the case when bordered and title is set
    borderTop: 0
  }), '&-scrollbar:not([rowspan])', {
    boxShadow: "0 ".concat(unit(lineWidth), " 0 ").concat(unit(lineWidth), " ").concat(tableHeaderBg)
  })), "".concat(componentCls, "-bordered ").concat(componentCls, "-cell-scrollbar"), {
    borderInlineEnd: tableBorder
  }));
};
export default genBorderedStyle;